import { useEffect, useState } from 'react';

import { ReactComponent as ArrowDownLine } from '../../assets/icons/ArrowDownLine.svg';

import classes from './Sheet.module.scss';

const Sheet = ({ className, defaultChildren, children, closeHandler }) => {
  const [visible, setVisible] = useState(false);

  const backdropClasses = [classes.backdrop];
  className && backdropClasses.push(className);

  useEffect(() => {
    setVisible(true);
  }, []);

  const containerClasses = [classes.container];
  visible && containerClasses.push(classes['container-visible']);

  const onClose = () => {
    setVisible(false);
    setTimeout(closeHandler, 200);
  };

  const onBackDropClick = ({ target: { className } }) => {
    if (className === classes.backdrop) onClose();
  };

  return (
    <div className={backdropClasses.join(' ')} tabIndex={0} onClick={onBackDropClick}>
      <div className={containerClasses.join(' ')}>
        {children}
        <span className={`pointer semibold-14 ${classes.close}`} onClick={onClose}>
          Cerrar
          <ArrowDownLine />
        </span>
      </div>
    </div>
  );
};

export default Sheet;
